import type {EcommerceData} from '@interfaces/yandexMetrika';
import type {PurchaseEvent} from '@interfaces/analytics';

declare global {
    type YMThirdParam = string | ((clientId: string) => void);

    interface Window {
        ym(id: number, eventType: string, thirdParam: YMThirdParam, params?: Params): Promise<void>;

        dataLayer?: EcommerceData[];
    }
}

interface Params {
    [key: string]: unknown;
}

interface PurchaseParams {
    coupon?: string;
    goal_id?: number;
    revenue?: number;
}

const YM_ID = 97789503;

function init() {
    window.dataLayer = window.dataLayer ?? [];
}

function triggerEvent(eventName: string, params = {}) {
    sendEvent(eventName, params);
}

function triggerEventWithPayment(event: PurchaseEvent) {
    sendEvent(event.eventName, {
        order_price: event.price,
        currency: event.currency,
    });
}

function sendEcommerceAction(id: string, params: PurchaseParams) {
    if (!window.dataLayer) {
        init();
    }

    window.dataLayer?.push({
        ecommerce: {
            currencyCode: 'RUB',
            purchase: {
                actionField: {
                    id,
                    ...params,
                },
                products: [
                    {
                        id,
                    },
                ],
            },
        },
    });
}

function sendEvent(eventName: string, params?: Params) {
    if (typeof window.ym !== 'undefined') {
        void window.ym(YM_ID, 'reachGoal', eventName, params);
    }
}

function triggerPageView() {
    if (typeof window.ym !== 'undefined') {
        void window.ym(YM_ID, 'hit', location.pathname + location.search);
    }
}

export default {
    init,
    triggerEvent,
    triggerEventWithPayment,
    triggerPageView,
    sendEcommerceAction,
};
